/**
 * @author: liaojianming
 * @date 2019-02-20
 * @description: 系统管理-用户模块
*/

import request from '@/plugin/axios'

const apiUrl = process.env.VUE_APP_API

// 用户登录
export function AccountLogin (data) {
  return request({
    url: apiUrl + 'system_user/login/anon',
    method: 'POST',
    data
  })
}
// 获取appId
export function AuthenticationGetDingAppId (data) {
  return request({
    url: apiUrl + 'system_user/getDingAppId/anon',
    method: 'GET',
    data
  })
}
// system_user/dingQRLogin/anon 扫码登录成功 验证code 获取token信息等
export function systemUserDingQRLoginAnon (data) {
  return request({
    url: apiUrl + 'system_user/dingQRLogin/anon',
    method: 'POST',
    data
  })
}

// 强制登录
export function systemSserAdminLoginAnon (data) {
  return request({
    url: apiUrl + 'system_user/adminLogin/anon',
    method: 'POST',
    data
  })
}

// 用户登出
export function AccountLogout (data) {
  return request({
    url: apiUrl + 'system_user/logout/anon',
    method: 'POST',
    data
  })
}

// 获取当前用户登录的数据
export function GetCurrentUserInfo (data) {
  return request({
    url: apiUrl + 'system_user/tree_menu_by_server_name_for_current_user',
    method: 'POST',
    data
  })
}

// 新增用户信息
export function AddAccountUser (data) {
  return request({
    url: apiUrl + 'system_user/save_for_ordinary',
    method: 'POST',
    data
  })
}

// 更新用户信息
export function UpdateAccountUser (data) {
  return request({
    url: apiUrl + 'system_user/update_for_ordinary',
    method: 'POST',
    data
  })
}

// 查询用户信息
export function QueryAccountUser (data) {
  return request({
    url: apiUrl + 'system_user/detail_by_id',
    method: 'POST',
    data
  })
}

// 查询用户分页
export function AccountUserPage (data) {
  return request({
    url: apiUrl + 'system_user/page_by_query',
    method: 'POST',
    data
  })
}

// 查询所有用户
export function QueryAllUser (data) {
  return request({
    url: apiUrl + 'system_user/list_by_query',
    method: 'POST',
    data
  })
}

// 用户自己修改密码
export function UpdateSelfPassword (data) {
  return request({
    url: apiUrl + 'system_user/update_password_for_self',
    method: 'POST',
    data
  })
}

// 用户自己修改初始密码
export function UpdateSelfInitialPassword (data) {
  return request({
    url: apiUrl + 'system_user/update_init_password_for_self',
    method: 'POST',
    data
  })
}

// 同步钉钉用户数据
export function SyncDingdingData (data) {
  return request({
    url: apiUrl + 'system_dept/sync_system_depts_from_dingding',
    method: 'POST',
    data
  })
}

// 业务归属设置
export function updateOrdinary (data) {
  return request({
    url: apiUrl + 'system_user/update_for_ordinary',
    method: 'POST',
    data
  })
}

// 角色修改用户密码
export function UpdatePwdForUser (data) {
  return request({
    url: apiUrl + 'system_user/update_password_for_role',
    method: 'POST',
    data
  })
}

// 输入手机号后，获取验证码
export function GetVerificationCode (data) {
  return request({
    url: apiUrl + 'system_user/getVerificationCode/anon',
    method: 'POST',
    data
  })
}

// 免密码登录
export function VerificationCodeLogin (data) {
  return request({
    url: apiUrl + 'system_user/verificationCodeLogin/anon',
    method: 'POST',
    data
  })
}


// 获取子系统菜单
export function getSubsystemMenu (data) {
  return request({
    url: apiUrl + 'server_config/list_by_query',
    method: 'POST',
    data
  })
}

// 查询数据字典
export function getDictData (data) {
  return request({
    url: apiUrl + 'dict_data/list_by_code',
    method: 'POST',
    data
  })
}